import instance from "../config";

//Lugar de votacion
export const getLugar = async ()=>{
  return instance.get('/lugar');
}

export const crearLugar = async (lugar, numeroMesas) => {
  const { data } = await instance.post("/lugar", { lugar, numeroMesas });
  return data;
};

export const editarLugar = async (id, lugar, numeroMesas) => {
  const { data } = await instance.put(`/lugar?id=${id}`, { lugar, numeroMesas });
  return data;
};

export const eliminarLugar = async (id) => {
  const { data } = await instance.delete(`/lugar?id=${id}`);
  return data;
};

// metodo para votantes
export const getElectores = async () => {
  return instance.get("/electores");
};

// líderes ya registrados (solo los nombres, de todos los electores) -> ["Ana", "Carlos", ...]
export const getLideres = async () => {
  const { data } = await instance.get("/electores/lideres");
  return data.lideres ?? [];
};

// metodo para resultado de votos
export const crearElectores = async (data) => {
  try {
    const response = await instance.post("/electores", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// metodo para buscar por la cedula
export const filtrocc = async (cedula) => {
  try {
    const { data } = await instance.get(`/electores/buscarcc?cedula=${cedula}`);
    return data;
  } catch (error) {
    return error;
  }
};

// metodo para editar
export const editarElector = async (
  id,
  cedula,
  nombres,
  apellidos,
  lugar,
  mesa,
  lider,
  direccion,
  telefono,
  compromiso,
  compromisoFecha,
) => {
  // lanza el error para que el modal muestre el mensaje del backend
  const { data } = await instance.put(`/electores/editar?id=${id}`, {
    cedula,
    nombres,
    apellidos,
    lugar,
    mesa,
    lider,
    direccion,
    telefono,
    compromiso,
    // vacía: compromiso sin fecha (no aparece en la agenda)
    compromisoFecha: compromisoFecha || null,
  });
  return data;
};

// metodo para marcar el compromiso del elector como cumplido o pendiente
// lanza el error para mostrar el mensaje del backend
export const editarCompromisoCumplido = async (id, cumplido) => {
  const { data } = await instance.put(`/electores/compromiso?id=${id}`, { cumplido });
  return data;
};

// metodo para validar la cedula antes de registrar
// -> { registrado: false } o { registrado: true, elector: {...} }
export const validarCedula = async (cedula) => {
  const { data } = await instance.get("/electores/validar-cedula", { params: { cedula } });
  return data;
};

// metodo para editar por el grupo
export const editarGrupo = async (id, grupo) => {
  console.log(id, grupo);

  try {
    const { data } = await instance.put(`/electores/grupo?id=${id}`, { grupo });
    return data;
  } catch (error) {
    return error;
  }
};

// metodo para eliminar
export const eliminarElector = async (cedula) => {
  try {
    const { data } = await instance.delete(
      `/electores/eliminar?cedula=${cedula}`,
    );
    return data;
  } catch (error) {
    return error;
  }
};

// metodo para filtra general
export const filtro = async (params) => {
  try {
    console.log(params);
    const { data } = await instance.get("/electores/filtro", { params });
    return data;
  } catch (error) {
    return error;
  }
};